const heroSliderBlock = (() => {

    const initBlock = (el) => {
        if(el.querySelector("[data-slider-container]").children.length > 1){
            initTinySlider(el);   
        }
        if(el.classList.contains('hero-slider--parallax')){
            document.addEventListener('scroll', () => {
                parallaxScrolling(el);
                _global.getOpacity(el);
            });            
        }
    };

    const initTinySlider = (el) => {
        const sliderId = el.dataset.sliderId;
        const autoplay = el.dataset.autoplay;
        const loop = el.dataset.loop;
        const pauseButton = el.querySelector("[data-pause]");
        let isPaused = false;
        const prevButton = el.querySelector("[data-prev]");
        const nextButton = el.querySelector("[data-next]");
        const tidyIndexes = () =>{
            prevButton.tabIndex = 0;
            nextButton.tabIndex = 0;
        }

        const slider = tns({
            container: el.querySelector("[data-slider-container]"),
            items: 1,
            slideBy: 'page',
            autoplay: autoplay === "True",
            loop: loop === "True",
            controls: true,
            navContainer: el.querySelector("[data-nav]"),
            prevButton: prevButton,
            nextButton: nextButton,
            autoplayButton: false,
            autoplayTimeout: 4000,
            speed: 900,
            onInit: function() {
                tidyIndexes()
            }
        });

        slider.events.on('transitionStart', function() {
            el.classList.add('hero-slider--is-transitioning');
        });

        slider.events.on('transitionEnd', function() {
            el.classList.remove('hero-slider--is-transitioning');
        });
        
        pauseButton && pauseButton.addEventListener("click", ()=>{
            if(isPaused){
                slider.play();
                pauseButton.classList.remove("hero-slider__controls__nav__pause--paused");
                isPaused = false;
            }else{
                slider.pause();
                pauseButton.classList.add("hero-slider__controls__nav__pause--paused");
                isPaused = true;
            }
        })
    };

    const parallaxScrolling = (el) => {
        const scrollY = window.scrollY;
        el.querySelectorAll('.hero-slider__item__media').forEach((media) => {
            media.style.top = `${(scrollY / 2)}px`;
        });
        el.querySelectorAll('.hero-slider__item__content').forEach((media) => {
            media.style.paddingBottom = `${(scrollY / 5) + 30}px`;
        });
    };

    return {initBlock};
})();

ControlBinders.register("[data-hero-slider]", el => heroSliderBlock.initBlock(el));